import {
  FETCH_METAL_COLOR_REQUEST,
  FETCH_METAL_COLOR_SUCCESS,
  FETCH_METAL_COLOR_FAILURE,
  ADD_METAL_COLOR_REQUEST,
  ADD_METAL_COLOR_SUCCESS,
  ADD_METAL_COLOR_FAILURE,
  UPDATE_METAL_COLOR_REQUEST,
  UPDATE_METAL_COLOR_SUCCESS,
  UPDATE_METAL_COLOR_FAILURE,
  DELETE_METAL_COLOR_REQUEST,
  DELETE_METAL_COLOR_SUCCESS,
  DELETE_METAL_COLOR_FAILURE,
  METAL_COLOR_FORM_ERROR,
  METAL_COLOR_FORM_SUCCESS,
  SET_METAL_COLOR_EDIT,
  CLEAR_METAL_COLOR_EDIT,
} from '../../../../types/masters/metalPurity/metalColor/metalColorTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingMetalColor: null,
};

const metalColorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_METAL_COLOR_REQUEST:
    case ADD_METAL_COLOR_REQUEST:
    case UPDATE_METAL_COLOR_REQUEST:
    case DELETE_METAL_COLOR_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_METAL_COLOR_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_METAL_COLOR_SUCCESS:
    case UPDATE_METAL_COLOR_SUCCESS:
    case DELETE_METAL_COLOR_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_METAL_COLOR_FAILURE:
    case ADD_METAL_COLOR_FAILURE:
    case UPDATE_METAL_COLOR_FAILURE:
    case DELETE_METAL_COLOR_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case METAL_COLOR_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case METAL_COLOR_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_METAL_COLOR_EDIT:
      return { ...state, editingMetalColor: action.payload };
    case CLEAR_METAL_COLOR_EDIT:
      return { ...state, editingMetalColor: null };
    default:
      return state;
  }
};

export default metalColorReducer; 